import {equals} from 'ol/coordinate.js';
import olFeature from 'ol/Feature.js';
import {unByKey} from 'ol/Observable.js';
import olGeomPoint from 'ol/geom/Point.js';
import olStyleStyle from 'ol/style/Style.js';
import olStyleText from 'ol/style/Text.js';
import olStyleFill from 'ol/style/Fill.js';
import olStyleStroke from 'ol/style/Stroke.js';
import olStyleCircle from 'ol/style/Circle.js';
import olSourceVector from 'ol/source/Vector.js';
import olEventsEventType from 'ol/events/EventType.js';
import olStyleIcon from 'ol/style/Icon.js'
import {listen} from 'ol/events.js';
import olLayerVector from 'ol/layer/Vector.js';
import olFormatGeoJSON from 'ol/format/GeoJSON.js';

/** @suppress {extraRequire} */
import ngeoToolActivate from 'ngeo/misc/ToolActivate.js';


/**
 * @private
 */
export class FireSimulatorController {

	/**
	* @param {!angular.Scope} $scope Scope.
	* @param {!ngeo.FeatureOverlayMgr} ngeoFeatureOverlayMgr Ngeo FeatureOverlay
	*     manager.
	* @param {!ngeo.ToolActivateMgr} ngeoToolActivateMgr Ngeo ToolActivate manager
	*     service.
	* @private
	* @ngInject
	* @ngdoc controller
	* @ngname NgeoInfra3dController
	*/
	constructor($scope, ngeoFeatureOverlayMgr, ngeoToolActivateMgr) {
		this.fireSimulatorInitialized_ = false;
		this.handleMapClickListenerKey_ = null;
		this.active;
		this.map;
		$scope.$watch(
			() => this.active,
			this.handleActiveChange_.bind(this)
		);
		this.url;
		this.location_ = null
		this.scope_ = $scope;
		this.featureOverlay_ = ngeoFeatureOverlayMgr.getFeatureOverlay();
		this.feature_ = new olFeature();
		this.point_ = new olGeomPoint([0, 0]);
		this.feature_.setGeometry(this.point_);
		
		this.drawFeature_ = new olFormatGeoJSON();
		this.drawSource_ = new olSourceVector();
		this.drawLayer_ = new olLayerVector({
			source: this.drawSource_,
			style: this.getGeojsonStyle
		});
	}
	// Call once at geomapfish loading
	$onInit() {
		console.log("component - oninit");
		// (2) Watch for both the active and location. When we have both, the
		//     state is considered 'ready'.
		this.scope_.$watch(
		() => {
			const isActive = this.active;
			const hasLocation = this.location_ !== null;
			return isActive && hasLocation;
		},
		this.handleReadyChange_.bind(this)
		);
	}
	
	// call when tool active is
	initComponent_() {
		window.firesimulator.init("fire-simulator", this.url, {}, () => {
			window.firesimulator.setOnCalculateArea(this.handleFireSimulatorOnCalculateArea, this);
			this.fireSimulatorInitialized_ = true;
		}, this);
		this.location_ = this.map.getView().getCenter() || [0, 0];
		this.point_.setCoordinates(this.location_);
		this.featureOverlay_.addFeature(this.feature_);
		this.map.addLayer(this.drawLayer_);
	}
	
	handleFireSimulatorOnCalculateArea(geojson) {
		this.drawSource_.clear();
		var features = this.drawFeature_.readFeatures(geojson);
		// temporaly disable draw on 2d map due to bug of geom refresh
		this.drawSource_.addFeatures(features);
	}
	
	// Fire simulator tool active (open) or not
	handleActiveChange_(active) {
		if (active) {
			if (!this.fireSimulatorInitialized_) {
				this.initComponent_();
			}
			this.handleMapClickListenerKey_ = listen(
				this.map,
				olEventsEventType.CLICK,
				this.handleMapClick_,
				this
			);
		} else {
			unByKey(this.handleMapClickListenerKey_);
			this.handleMapClickListenerKey_ = null;
		}
	}
	
	handleMapClick_(evt) {
		if (this.fireSimulatorInitialized_) {
			this.point_.setCoordinates(evt.coordinate);
			// send location to form (external)
			window.firesimulator.loadPosition(evt.coordinate[0], evt.coordinate[1]);
		}
	}
	
	handleReadyChange_(ready, oldReady) {
		if (ready === oldReady) {
			return;
		}

		if (ready) {
			// Add current position to feature overlay
			this.featureOverlay_.addFeature(this.feature_);
			this.drawLayer_.setVisible(true);

			// Display available media
			//this.ennLayer_.setVisible(true);

		} else {
			// Remove current position from feature overlay
			this.featureOverlay_.removeFeature(this.feature_);
			this.drawLayer_.setVisible(false);
		}
	}
	
	getGeojsonStyle(feature) {
		var fillStyle = new olStyleFill({color: feature.get('color')});
		var strokeStyle = new olStyleStroke({color: feature.get('color'), width: 3.0});
		var textStyle = new olStyleText({
			textAlign: 'center',
			textBaseline: 'bottom',
			placement: 'LINE',
			font: '12px Verdana',
			text: feature.get('label'),
			fill: new olStyleFill({color: '#FFFFFF'}),
			stroke: new olStyleStroke({color: feature.get('color'), width: 3.0}),
			overflow: true
		});
		var styles = {
			'Point': new olStyleStyle({
				image: new olStyleCircle({
					radius: 5,
					fill: fillStyle,
					stroke: strokeStyle,
				}),
				text: textStyle,
			}),
			'LineString': new olStyleStyle({
				stroke: strokeStyle,
				text: textStyle,
			}),
			'Polygon': new olStyleStyle({
				stroke: strokeStyle,
				fill: fillStyle,
				text: textStyle,
			}),
			'MultiPolygon': new olStyleStyle({
				stroke: strokeStyle,
				fill: fillStyle,
				text: textStyle,
			}),
		};
		return styles[feature.getGeometry().getType()];
	}
}

const name = 'rudazFireSimulator';
const module = angular.module(name, []).component(name, {
  bindings: {
    'active': '<',
    'url': '<',
    'map': '<'
  },
  controller: FireSimulatorController,
  template: '<div id="fire-simulator"></div>'
});

export default  module;